import React from 'react';
import { Link } from 'react-router-dom';
import { useContact } from '../../hooks/useContact';

const Footer: React.FC = () => {
  const { contactInfo } = useContact();

  const renderSocialIcon = (
    type: 'whatsapp' | 'facebook' | 'youtube' | 'tiktok',
    link: string | undefined,
    bgColor: string
  ) => {
    const icons = {
      whatsapp: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      ),
      facebook: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      youtube: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      ),
      tiktok: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
        </svg>
      )
    };

    return link ? (
      <a
        href={type === 'whatsapp' ? `https://wa.me/${link}` : link}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center justify-center w-10 h-10 rounded-xl ${bgColor} text-white transition-all duration-300 hover:scale-105 hover:shadow-lg`}
        title={type.charAt(0).toUpperCase() + type.slice(1)}
      >
        {icons[type]}
      </a>
    ) : null;
  };

  return (
    <footer className="bg-white text-gray-800 border-t border-gray-200" dir="rtl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <div className="text-center md:text-right">
            <h3 className="text-2xl font-bold text-gray-800 mb-2">
              منصة <span className="text-orange-600">مستر وليد المصري</span>
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              منصة تعليمية متخصصة في تدريس اللغة الإنجليزية للثانوية العامة
            </p>
            <p className="text-orange-600 font-semibold text-sm">
              العلامة الكاملة في الإنجليزي مضمونة معانا! 🎯
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center">
            <h4 className="text-lg font-semibold mb-4 text-gray-800">روابط سريعة</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-gray-600 hover:text-orange-600 transition-colors font-medium">
                الرئيسية
              </Link>
             
              <button 
                onClick={() => {
                  const coursesSection = document.getElementById('courses-section');
                  if (coursesSection) {
                    coursesSection.scrollIntoView({ behavior: 'smooth' });
                  } else {
                    window.location.href = '/#courses-section';
                  }
                }}
                className="block text-gray-600 hover:text-orange-600 transition-colors font-medium w-full text-center"
              >
                الكورسات
              </button>
              <Link to="/parent-monitoring" className="block text-gray-600 hover:text-orange-600 transition-colors font-medium">
                متابعة ولي الأمر
              </Link>
            </div>
          </div>

          {/* Contact & Social */}
          <div className="text-center">
            <p className="text-sm text-gray-700 mb-4 font-bold">تواصل معانا عبر وسائل التواصل الأجتماعي</p>
            {contactInfo?.whatsApp_Number && (
              <div className="flex items-center justify-center gap-2 mb-2">
                
              </div>
            )}
            
            {/* Social Media */}
            <div className="inline-flex items-center justify-center gap-3 flex-wrap rounded-2xl p-4 bg-white/80 backdrop-blur-md shadow-lg shadow-orange-500/20 border-2 border-orange-600 hover:shadow-orange-500/30 hover:-translate-y-0.5 transition-all duration-300">
              {contactInfo?.whatsApp_Number && renderSocialIcon('whatsapp', contactInfo.whatsApp_Number, 'bg-green-600 hover:bg-green-700')}
              {contactInfo?.facebook_Page && renderSocialIcon('facebook', contactInfo.facebook_Page, 'bg-blue-600 hover:bg-blue-700')}
              {contactInfo?.youTube_Channel && renderSocialIcon('youtube', contactInfo.youTube_Channel, 'bg-red-600 hover:bg-red-700')}
              {contactInfo?.tiktokChannel && renderSocialIcon('tiktok', contactInfo.tiktokChannel, 'bg-gray-800 hover:bg-gray-900')}
            </div>
          </div>
        </div>

        {/* EduCraft Section */}
        <div className="border-t border-gray-200 pt-6">
          <div className="text-center">
            <p className="text-gray-600 text-sm mb-2">
              تم التطوير بواسطة
            </p>
            <div className="flex items-center justify-center gap-2">
              <a 
                href="https://wa.me/201114706613"
                target="_blank"
                rel="noopener noreferrer"
                className="group cursor-pointer"
              >
                <span className="text-xl font-bold bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent group-hover:from-orange-700 group-hover:to-red-700 transition-all duration-300">
                  EduCraft
                </span>
                <span className="text-2xl group-hover:scale-110 transition-transform duration-300">🚀</span>
              </a>
            </div>
            <p className="text-orange-600 text-xs font-medium mt-1">
              منصات تعليمية احترافية
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-200 pt-4 mt-6 text-center">
          <p className="text-gray-500 text-sm">
            © 2024 منصة مستر وليد المصري. جميع الحقوق محفوظة.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;